import { track } from "@amplitude/analytics-browser";
import { getUserRegionAndIP } from "./amplitudeUserProperties";
import { amplitudeEventsName } from "./amplitudeEvents";

export const trackViewedScreen = async (screenName: string, userId: string, referrer?: string) => {
    const result = await getUserRegionAndIP();
    const eventProperties = {
        ip_address: result?.ip, 
        referrer: referrer || document.referrer, 
        screen_name: screenName,
        userId: userId,
        screen_viewed_at: new Date().toISOString(),
    };

    try {
        track(amplitudeEventsName.VIEWD_SCREEN, eventProperties);
    } catch (error) {
        console.error('Failed to track viewed screen event:', error);
    }
};

